module.exports = __webpack_public_path__ + "static/Ozgur-c40071ed66c31d484d876e0c6af35a4b.jpg";